import React from 'react';
import './JobDescription.css';

export default class JobDescription extends React.Component {
	
	static defaultProps = {
		header: 'header',
		text: 'title',
		className: ''
	};
	
	render = () => {
		return (
			<div className={`${this.props.className} rcg-description-container`}>
				
				<div>
					<h3 className="rcg-small-title text-outline">Job Description</h3>
				</div>
				
				
				<div className="rcg-subtitle">
					<p className="user-content" dangerouslySetInnerHTML={{ __html: this.props.text }}/>
				</div>
			
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/components/VacancyOverview/JobDescription.js